import React, { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { useLocation, withRouter } from 'react-router-dom';

import { Button, SideBySide, Theme } from '../../components';
import { useQuery } from '../../hooks/use-query';
import { Role } from '../../models';
import { FrontOfficeLink, RestoAdminLink } from '../../models/Routes';
import { userActions, userSelectors } from '../../redux';
import { UserService } from '../../services/UserService';

import './Error.scss';

const Error: FC<RouteComponentProps> = ({ location }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const userInfo = useSelector(userSelectors.getUserInfo);

  useEffect(() => {
    dispatch(userActions.resetLoginError());
  });

  const redirectToLogin = () => {
    UserService.login(location);
  };

  const queryParams: URLSearchParams = useQuery(useLocation);
  return (
    <div className='error-view center-content'>
      <p>{t(queryParams.get('message') || 'errorSomethingWentWrong')}</p>
      <SideBySide>
        {!userInfo && (
          <Button theme={Theme.SECONDARY} onClickCallback={redirectToLogin}>
            {t('btnTryLoginAgain')}
          </Button>
        )}
        {!!userInfo && userInfo.roles.includes(Role.RESTO_ADMIN) && (
          <Button theme={Theme.SECONDARY} link={RestoAdminLink.ROOT}>
            {t('btnToRestoAdminDashboard')}
          </Button>
        )}
        {!!userInfo && (
          <Button theme={Theme.SECONDARY} link={FrontOfficeLink.ROOT}>
            {t('btnToFrontOffice')}
          </Button>
        )}
      </SideBySide>
    </div>
  );
};

export default withRouter(Error);
